module.exports = __webpack_public_path__ + "img/16581312_L.374b5303.png";